import React from "react";
import Back from "../common/Back";
import Heading from "../common/Heading";
import img from "../images/about.jpg";
import "./about.css";

const About = () => {
  const handleMoreAboutUs = () => {
    window.location.href = "https://g.page/r/CYJcdLp6d9xrEAE/review";
  };

  return (
    <>
      <section className='about'>
        <Back name='About Us' title='About Us - Who We Are?' cover={img} />
        <div className='container flex mtop'>
          <div className='left row'>
            <Heading title='Our Agency Story' subtitle='Check out our company story and work process' />

            <p>We offer a wide range of aluminium products, including windows, doors, and frames, all crafted from durable, high-quality materials to withstand the test of time. Our products are perfect for creating sleek, modern designs while ensuring energy efficiency and security.</p>
            <p>Additionally, we provide partitioning solutions that help maximize space and create functional, flexible layouts. Whether you're looking to divide large office spaces or transform your home into a more organized and comfortable environment, our partitioning systems can meet your needs. We offer a variety of materials, including glass and aluminium, to suit different styles and requirements.</p>
            <button className='btn2' onClick={handleMoreAboutUs}>More About Us</button>
          </div>
          <div className='right row'>
            <img src='./immio.jpg' alt='' />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
